import {createContext, useContext} from 'react'

export const PropertiesContext = createContext([{}, () => {}])
export const useProperties = () => useContext(PropertiesContext)
